import * as React from 'react';
import { Row, Col } from 'reactstrap';

export const Loading = () => {
    return (
        <React.Fragment>
        <Row style={{minHeight:"100vh", alignItems:"center", margin: "0"}}>
                <Col sm="12" md={{ size: 6, offset: 3 }} style={{textAlign: "center"}}>
                    <div className="spinner-border" role="status" style={{textAlign: "center"}}>
                        <span  className="sr-only">Loading...</span>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
}